<div class="decline-dialog">
  <!-- Close Button -->
  <button
    class="decline-dialog__close-btn"
    (click)="onClose()"
    type="button"
    aria-label="Close"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#96080B"/>
      <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <!-- Title -->
  <h2 class="decline-dialog__title">{{ (data.keyPrefix + '.decline_dialog_title') | translateLang }}</h2>

  <!-- Subtitle -->
  <p class="decline-dialog__subtitle">
    {{ (data.keyPrefix + '.decline_dialog_subtitle') | translateLang }}
  </p>

  <!-- Textarea -->
  <textarea
    class="decline-dialog__textarea"
    [placeholder]="(data.keyPrefix + '.decline_dialog_placeholder') | translateLang"
    [(ngModel)]="declineReason"
    rows="5"
  ></textarea>

  <!-- Actions -->
  <div class="decline-dialog__actions">
    <button
      class="decline-dialog__btn decline-dialog__btn--cancel"
      (click)="onCancel()"
      type="button"
    >
      {{ (data.keyPrefix + '.decline_dialog_cancel_button') | translateLang }}
    </button>
    <button
      class="decline-dialog__btn decline-dialog__btn--decline"
      (click)="onDecline()"
      type="button"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 1.5L12.5 12.5M12.5 1.5L1.5 12.5" stroke="white" stroke-width="2.2" stroke-linecap="round"/>
      </svg>
      {{ (data.keyPrefix + '.decline_dialog_decline_button') | translateLang }}
    </button>
  </div>
</div>
